var map = {
	"./en/account.json": [
		9208,
		9208
	],
	"./en/cloud-storytelling.json": [
		51097,
		1097
	],
	"./en/cognia.json": [
		57078,
		7078
	],
	"./en/common.json": [
		86042,
		6042
	],
	"./en/credits.json": [
		90813,
		813
	],
	"./en/curriculum.json": [
		26488,
		6488
	],
	"./en/expand-subject.json": [
		31802,
		1802
	],
	"./en/home.json": [
		5256,
		5256
	],
	"./en/leave.json": [
		28476,
		8476
	],
	"./en/order.json": [
		59023,
		9023
	],
	"./en/points.json": [
		61136,
		1136
	],
	"./en/profile.json": [
		7414,
		7414
	],
	"./en/renewal.json": [
		10119,
		119
	],
	"./en/resource.json": [
		99359,
		9359
	],
	"./en/rewards.json": [
		63695,
		3695
	],
	"./en/study.json": [
		49894,
		9894
	],
	"./en/terms.json": [
		1476,
		1476
	],
	"./zh/account.json": [
		82005,
		2005
	],
	"./zh/cloud-storytelling.json": [
		67174,
		7174
	],
	"./zh/cognia.json": [
		90505,
		505
	],
	"./zh/common.json": [
		10285,
		285
	],
	"./zh/credits.json": [
		50928,
		928
	],
	"./zh/curriculum.json": [
		255,
		255
	],
	"./zh/expand-subject.json": [
		26053,
		6053
	],
	"./zh/home.json": [
		84731,
		4731
	],
	"./zh/leave.json": [
		28993,
		8993
	],
	"./zh/order.json": [
		97182,
		7182
	],
	"./zh/points.json": [
		42675,
		2675
	],
	"./zh/profile.json": [
		85371,
		5371
	],
	"./zh/renewal.json": [
		14674,
		4674
	],
	"./zh/resource.json": [
		9552,
		9552
	],
	"./zh/rewards.json": [
		41498,
		1498
	],
	"./zh/study.json": [
		72411,
		2411
	],
	"./zh/terms.json": [
		7973,
		7973
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96915;
module.exports = webpackAsyncContext;